//
//
//
//
//
//
//

export default {
  methods:{
    go(){
      this.$router.push("/mine");
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/checksuccess.vue